import { inject } from 'aurelia-framework';
import { bindable } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { EnvironmentService } from '../../../services/environmentService';
import { WebRtcAPI } from '../../../services/webrtcAPI';
import { UserMessageService } from "../../../services/userMessageService";

@inject(EnvironmentService, WebRtcAPI, UserMessageService)
export class FileUploadCustomElement {
    @bindable recorderReady;
    @bindable recordingComplete;
    @bindable saveComplete;
    @bindable reportError;
    @bindable reportLogMessage;
    @bindable captureKey;
    @bindable captureType;
    @bindable submit;
    @bindable maxRecordTime;
    @bindable uploadOnly;
    constructor(envService, api, userMessageService) {

        this.envService = envService;
        this.userMessageService = userMessageService;
        this.api = api;

        this.uploading = false;

        this.uploadProgress = 0;

        this.fileSizeLimit = false;
        this.fileTypeInvalid = false;
        this.videoName = null;
        this.uploadError = false;

        this.validFilesTypes = ["mov", "mp4", "webm"];

//        this.captureType = window.location.href.split("=")[1]
        this.portrait = false;

    }

    attached() {
        if(this.uploadOnly) {
            this.fileUpload.removeAttribute("capture");
        }
    }


    display() {

        this.fileSizeLimit = false;
        this.fileTypeInvalid = false;
        this.uploadingMessage.hidden = true;
        this.recorded = false;
        this.uploadError = false;
        this.recorderReady();
    }


    fileSelected() {
        this.recorded = true;
        const file = this.video_files[0];
        
        this.reportLogMessage({ msg: "File selected: " + file.name });
        this.reportLogMessage({ msg: "File size: " + file.size });
        this.fileSizeLimit = file.size > (200 * 1024 * 1024);

        var re = /(?:\.([^.]+))?$/;
        this.fileTypeInvalid = !this.validFilesTypes.includes(re.exec(file.name)[1].toLowerCase());
        this.videoName = file.name;

        // For Firefox, pass the file directly instead of URL
        if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
            this.hasVideoGotAudio(file).then(() => {
                this.recordingComplete();
            });
        } else {
            const fileUrl = window.URL.createObjectURL(file);
            this.hasVideoGotAudio(fileUrl).then(() => {
                window.URL.revokeObjectURL(fileUrl);
                this.recordingComplete();
            });
        }
    }

    save(upload,video_id, is_branded_video = false) {
        //this method is being used to upload videos
        this.uploadError = false;
        this.uploading = true;
        this.uploadingMessage.hidden = false;
        this.uploadflag = upload;
        this.uploadProgress = 0;
        this.video_email = false;

    //     var ua = navigator.userAgent.toLowerCase();

    //     if (ua.indexOf("ipad") != -1 || ua.indexOf("iphone") != -1 || ua.indexOf("ipod") != -1) {
    //         console.log("portait iphone true fileupload");
    //         this.portrait = true;
    //  }

    this.portrait = this.iOS();
        console.log("iphone portrait mode", this.portrait);
        if(this.captureType==3 || upload == true)
            this.video_email = true;

        if(this.captureType==5 || upload == true)
            this.video_message = true;

        this.api.saveVideo(
            this.portrait,
            this.video_files[0],
            this.captureKey,
            this.uploadflag,
            video_id,
            this.video_email,
            this.video_message,
            this.uploadProgressNotification.bind(this),
            this.uploadCapturedVideoComplete.bind(this),
            this.uploadCapturedVideoError.bind(this),
            is_branded_video
        );

    }

    retryUpload() {
        this.reportLogMessage({ msg: "Retrying Upload" });
        this.save();
    }
    uploadFile(fileUpload) {
        // this.file = new File([this.fileUpload.getBlob()], fileUpload[0].name, {
        //     type: fileUpload[0].type
        // });
        this.video_files = fileUpload;
    }

    uploadProgressNotification(data) {
        this.uploadProgress = Math.round(data.loaded * 100 / data.total);
        localStorage.setItem('uploadFileProgress', this.uploadProgress);

    }

    uploadCapturedVideoComplete(file_name) {
        localStorage.setItem('VideoEmailFileName', file_name.preview_file);

        // var ua = navigator.userAgent.toLowerCase();
        // if (ua.indexOf("ipad") != -1 || ua.indexOf("iphone") != -1 || ua.indexOf("ipod") != -1) {
        //         console.log("portait iphone true");
        //         this.portrait = true;

        //  }
        // console.log("portrait", this.portrait);

        // localStorage.setItem("portrait",this.portrait);
         console.log("save video complete",file_name);
         localStorage.setItem('VideoFileName', file_name.filename);
        this.uploadError = false;
        this.saveComplete({ filename: file_name.filename });

    }

    uploadCapturedVideoError(msg, reason) {

        this.uploadError = true;
        console.error("Error uploading video: " + JSON.stringify(reason));
        this.reportLogMessage({ msg: msg });
        if(reason)
            this.reportLogMessage({ msg: reason });

    }

    iOS() {
        return [
          'iPad Simulator',
          'iPhone Simulator',
          'iPod Simulator',
          'iPad',
          'iPhone',
          'iPod'
        ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
      }



      hasAudio(video) {
        try {
          const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
          const isChrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1;

          if (isFirefox) {
            return video.mozHasAudio !== false; // mozHasAudio is undefined when audio exists
          }
          
          if (isChrome) {
            // For Chrome, check multiple audio properties
            const hasAudioTracks = video.audioTracks && video.audioTracks.length > 0;
            // In Chrome, webkitAudioDecodedByteCount might be 0 initially even with audio
            const hasWebkitAudio = video.webkitAudioDecodedByteCount !== undefined;
            let hasMediaSource = false;
            try {
              if (video.captureStream) {
                hasMediaSource = video.captureStream().getAudioTracks().length > 0;
              }
            } catch (e) {
              console.log('captureStream check failed:', e);
            }
            
            console.log('Chrome audio detection:', {
              hasAudioTracks,
              hasWebkitAudio,
              hasMediaSource,
              audioTracks: video.audioTracks,
              webkitCount: video.webkitAudioDecodedByteCount
            });

            const hasAudio = hasAudioTracks || hasWebkitAudio || hasMediaSource; 
            console.log('Final audio detection result:', hasAudio); // Log the final result
            console.log('Final audio detection result:', hasAudio);
            return hasAudio;
          }
          
          // For other browsers
          return Boolean(
            (video.audioTracks && video.audioTracks.length > 0) || // Standard
            video.mozHasAudio || // Firefox fallback
            (video.audioTracks && video.audioTracks[0] && video.audioTracks[0].enabled) // Track enabled check
          );
        } catch (e) {
          console.error('Error checking audio:', e);
          return true; // For Chrome, assume audio exists on error to avoid false warnings
        }
      }
      showMessage() {
        this.userMessageService.setUserWarning(
          "file",
          "<span>* Warning this video has NO AUDIO track.*</span><br/><br/><p style='margin-right:55px'>Please record video with audio track. After recoding, play it back to make sure you can hear and see yourself.<p style='text-align:center;margin-right:55px'>OR</p><p style='margin-right:55px'>If you do not want audio in this video then proceed with the video.</p>"
        );
      }
      hasVideoGotAudio(src) {
        return new Promise((resolve) => {
          const video = document.createElement("video");
          video.muted = true;
          video.preload = "metadata";

          const cleanup = () => {
            if (video.src && video.src.startsWith('blob:')) {
              URL.revokeObjectURL(video.src);
            }
            video.remove();
          };

          const checkAudio = () => {
            try {
              // For Chrome, we need a small delay to ensure audio properties are initialized
              if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
                video.play().then(() => {
                setTimeout(() => {
                    const hasAudioTrack = this.hasAudio(video); // Adjusted delay for audio properties
                    console.log('Audio detection result:', hasAudioTrack);
                    console.log('Audio detection result:', hasAudioTrack);
                    
                    if (!hasAudioTrack) {
                      this.showMessage();
                      this.disabledUpload = true;
                    }
                    
                    video.pause();
                    cleanup();
                    resolve(hasAudioTrack);
                  }, 100); // Small delay to ensure audio properties are available
                }).catch(e => {
                  console.error('Error playing video:', e);
                  cleanup();
                  this.showMessage();
                  this.disabledUpload = true;
                  resolve(false);
                });
              } else {
                const hasAudioTrack = this.hasAudio(video);
                console.log('Audio detection result:', hasAudioTrack);
                
                if (!hasAudioTrack) {
                  this.showMessage();
                  this.disabledUpload = true;
                }
                
                cleanup();
                resolve(hasAudioTrack);
              }
            } catch (e) {
              console.error('Error in checkAudio:', e);
              cleanup();
              this.showMessage();
              this.disabledUpload = true;
              resolve(false);
            }
          };

          const onError = (e) => {
            console.error('Video loading error:', e);
            cleanup();
            this.showMessage(); // Show warning on error
            this.disabledUpload = true;
            resolve(false);
          };

          video.addEventListener("error", onError);

          video.addEventListener("loadedmetadata", () => {
            // Wait a bit to ensure audio tracks are loaded
            setTimeout(checkAudio, 500);
          });

          try {
            if (typeof src === 'string') {
              video.src = src;
            } else {
              video.src = URL.createObjectURL(src);
            }
            video.load();
          } catch (e) {
            onError(e);
          }
        });
      }
}







